import { useMjmlStore } from "@/stores/mjmlStore";
import { useNotificationsStore } from "@/stores/notifications";
import { useI18n } from "vue-i18n";

export interface UpdateTemplateOptions {
  skipSnapshot?: boolean;
}

export default () => {
  const mjmlStore = useMjmlStore();
  const notificationsStore = useNotificationsStore();
  const { t } = useI18n();

  function updateTemplate(json: any, options?: UpdateTemplateOptions) {
    const skipSnapshot = options?.skipSnapshot ?? false;

    // Parse JSON if string
    let _json;
    try {
      if (typeof json === "string") {
        _json = JSON.parse(json);
      } else {
        _json = json;
      }
    } catch (e) {
      console.error("updateTemplate: Invalid JSON", e);
      sendErrorCallback("updateTemplate", "Invalid JSON format");
      notificationsStore.createNotification({
        type: "error",
        text: t("layout.update_template_error") || "Failed to update template",
      });
      return;
    }

    // Handle wrapped template format (like loadJson does)
    let body: { template?: any; feeds?: any; datafeeds?: any } = {};
    if (!_json.template) {
      body.template = _json;
    } else {
      body = _json;
    }

    // Take snapshot BEFORE updating (unless skipped)
    if (!skipSnapshot) {
      mjmlStore.takeSnapshot();
    }

    // Use setMjml which handles validation internally
    mjmlStore.setMjml(body.template);

    // Handle feeds and datafeeds if present
    if (body.feeds) {
      mjmlStore.feeds = body.feeds;
    }
    if (body.datafeeds) {
      mjmlStore.datafeeds = body.datafeeds;
    }

    // Fix anchor tag style (same as loadJson does)
    mjmlStore.fixAnchorTagStyle();

    // Mark as edited
    mjmlStore.edittedWithoutSave = true;

    // Send success callback to parent
    const message = {
      type: "callback",
      action: "onTemplateUpdated",
      data: {
        args: [],
      },
    };
    window.parent.postMessage(JSON.parse(JSON.stringify(message)), "*");
  }

  function sendErrorCallback(source: string, errorMessage: string) {
    const message = {
      type: "callback",
      action: "onError",
      data: {
        args: [source, errorMessage],
      },
    };
    window.parent.postMessage(JSON.parse(JSON.stringify(message)), "*");
  }

  return {
    updateTemplate,
  };
};
